module.exports = __webpack_public_path__ + "galleri-sensitivity-values.b59fdd4ca10924ce23152da6ef94cd3e.png";